// Copyright (c) 2023 WiseTime. All rights reserved.

import {
  DeleteTimelineMarkerRequest,
} from "../../../generated/wisetime/user/timeline/v4/timeline_pb"
import { concat, mergeMap, Observable, of } from "rxjs"
import { Empty } from "google-protobuf/google/protobuf/empty_pb"
import { Action } from "redux"
import { catchError, filter } from "rxjs/operators"
import * as TimelineSlice from "../slices/timeline"
import { showSnackBar } from "../../snackbar/actions"
import { t } from "@lingui/macro"
import { grpc } from "../../../app/rpc/executor"
import { timelineClient } from "../../../app/rpc/client"
import * as TimelineActions from "../actions"

type DeleteTimelineMarkerRpc = (request: DeleteTimelineMarkerRequest) => Observable<Empty>

export const deleteTimelineMarker = (deleteTimelineMarkerRpc: DeleteTimelineMarkerRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(TimelineActions.deleteTimelineMarker.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(deleteTimelineMarkerRpc),
          mergeMap(_ =>
            concat(
              of(TimelineSlice.deleteTimelineMarker(action.payload.getId())),
              of(showSnackBar({
                message: t({ id: "msg_timeline_marker_deleted", message: "Marker deleted." }),
                messageType: "SUCCESS",
              }))
            )
          ),
          catchError(handleError),
        )
      ),
    )

const deleteTimelineMarkerRpc = (request: DeleteTimelineMarkerRequest): Observable<Empty> =>
  grpc(() => timelineClient.deleteTimelineMarker(request, null))

const handleError = () => {
  return of(showSnackBar({
    message: t({ id: "msg_timeline_marker_delete_failed", message: "Failed to delete marker. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
    messageType: "ERROR",
  }))
}

export default deleteTimelineMarker(deleteTimelineMarkerRpc)
